import { defineStore } from 'pinia'

export const useShowCaseStore = defineStore('showcase', {
  state: () => ({
    dialog: {},
    parentDialogs: [],
    dialogHistory: [],
    showLocationHeader: false,
    drawerWidth: 350,
    footerHeight: 0,
    properties: {},
  }),
  getters: {
    getDialogState() {
      return (dialog) => this.dialog[dialog]
    },
    getDialogProperties() {
      return (dialog) => {
        return this.properties[dialog] || {}
      }
    },
  },
  actions: {
    updateDialogState({ dialog, val, parentDialog }) {
      if (parentDialog && !this.parentDialogs.includes(dialog)) {
        this.parentDialogs.push(parentDialog)
      }

      if (this.parentDialogs.includes(dialog)) this.parentDialogs.pop()

      if (val) {
        for (let key in this.dialog) {
          if (
            key != dialog &&
            !this.parentDialogs.includes(key) &&
            key != 'BetaModeDialog'
          )
            this.dialog[key] = false
        }
      }

      if (val) {
        this.dialogHistory = [...this.dialogHistory, dialog]
      } else {
        this.dialogHistory = this.dialogHistory.filter(
          (hDialog) => hDialog !== dialog
        )
      }

      // Vue.set(state.dialog, dialog, val)
      this.dialog = { ...this.dialog, [dialog]: val }
    },
    updateDrawerWidth(val) {
      this.drawerWidth = val
    },
    updateLocationHeader(val) {
      this.showLocationHeader = val
    },
    setDialogProperties({ dialog, properties, refresh = false }) {
      if (!this.properties[dialog]) {
        this.properties = Object.assign({}, this.properties, { [dialog]: {} })
      }
      if (refresh) {
        this.properties[dialog] = Object.assign({}, properties)
      } else {
        this.properties[dialog] = Object.assign(
          {},
          this.properties[dialog],
          properties
        )
      }
    },
    updateFooterHeight(val) {
      this.footerHeight = val
    },
    deleteDialogProperties(dialog) {
      delete this.properties[dialog]
    },
  },
})
